import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HeaderColor } from '@ionic-native/header-color';

import { WelcomePage } from '../pages/welcome/welcome';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = WelcomePage;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    private headerColor: HeaderColor
  ){
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
      this.headerColor.tint('#e6ebf1');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts